import { api } from "@/utils/api";
import { Alert } from "./Alert";
import { sanitizePathParam } from "@/utils/sanitize";

export default class AlertRepository {
  async postAlert(alert: Alert): Promise<boolean> {
    const result = await api.post(`issues/alerts`, alert);
    return result.data;
  }

  async postUpadateAlert(alertId: number, alert: Alert): Promise<boolean> {
    const aid = sanitizePathParam(alertId);
    const result = await api.post(`issues/alerts/${aid}`, alert);
    return result.data;
  }

  async getAlerts({
    name = null,
    enable = null,
    page,
    size,
  }: {
    name: null | string;
    enable: null | boolean;
    page: number;
    size: number;
  }) {
    const response = await api.get(`issues/alerts`, {
      params: { name, enable, page, size },
    });
    return response.data;
  }

  async getAlertById(alertId: number) {
    const aid = sanitizePathParam(alertId);
    const response = await api.get(`issues/alerts/${aid}`);
    return response.data;
  }

  async deleteAlert(alertId: number): Promise<void> {
    const aid = sanitizePathParam(alertId);
    await api.delete(`issues/alerts/${aid}`);
  }
}
